import { ConfigFn } from '@config/types'

const config = (({ publication }) =>
  ({
    publication,
  }) as const) satisfies ConfigFn

export default config
